module.exports = __webpack_public_path__ + "static/media/espiga_cuauhtemoc.fb739600.png";